import Roles from "../constants/roles";

function getRouteLocation(role) {
    if (role === Roles.Admin) {
        return '/leads';
    }
    else if (role === Roles.Counsellor) {
        return '/leads'
    }
}

export { getRouteLocation };